import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// QUINLAN
import BaseMixer from "../../BaseMixer";
import { IPageDTO } from "@/store/models/pageManager/PageManager";
let PageUpsertComponent = /** @class */ (() => {
    var _a;
    let PageUpsertComponent = class PageUpsertComponent extends Mixins(BaseMixer) {
        checkAndSendSave() {
            this.validateProvider("pageNameValProvider").then((res) => {
                if (res.valid) {
                    return this.save();
                }
            });
        }
        save() { }
        cancel() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IPageDTO !== "undefined" && IPageDTO) === "function" ? _a : Object)
    ], PageUpsertComponent.prototype, "model", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageUpsertComponent.prototype, "save", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PageUpsertComponent.prototype, "cancel", null);
    PageUpsertComponent = __decorate([
        Component
    ], PageUpsertComponent);
    return PageUpsertComponent;
})();
export default PageUpsertComponent;
